import { useEffect } from 'react';
import { StudyApi } from 'api';
import { first } from 'lodash/array';
import { sortBy } from 'lodash/collection';
import { debounce } from 'lodash/function';
import { isEmpty } from 'lodash/lang';

import StudyPcn from 'components/eui/EuiFiltersContext/controls/StudyPcn/StudyPcn';
import { useEuiFiltersDispatch, useEuiFiltersState } from 'components/eui/EuiFiltersContext/EuiFiltersContext';
import { setCacheProcessor, setInitialStateProcessor } from 'components/eui/EuiFiltersContext/processors';
import { FRS_READY } from 'components/eui/EuiFiltersContext/reducer';

const debounceCache = debounce(cb => cb(), 500);

export default function FiltersSection({ onStudyChange }) {
  const state = useEuiFiltersState();
  const dispatch = useEuiFiltersDispatch();

  const { schema } = state;

  const status = state.schema?.status;

  useEffect(
    function() {
      if (status !== FRS_READY) {
        return;
      }

      onStudyChange(state.study?.value?.id);

      debounceCache(function() {
        dispatch({
          type: 'PERFORM',
          processor: setCacheProcessor
        });
      });
    },
    [dispatch, onStudyChange, state, status]
  );

  useEffect(
    function() {
      if (status) return;
      dispatch({
        type: 'PERFORM_INITIALIZATION',
        processor: setInitialStateProcessor,
        payload: {
          study: {
            source: [],
            value: null
          },
          cacheCollector
        }
      });
    },
    [dispatch, status]
  );

  if (isEmpty(schema)) return null;

  return <StudyPcn uniqKey="study" state={state} dispatch={dispatch} getStudies={getStudies} />;
}

async function getStudies() {
  const { data } = await StudyApi.populateNonCanceledStudyList();
  const source = sortBy(
    data.response.map(({ uniqueIdentifier: id, studyName: name, pcn }) => ({ id, name, pcn })),
    ['name']
  );
  const value = first(source);
  return {
    source,
    value
  };
}

function cacheCollector(state) {
  return {
    study: {
      value: state?.study?.value
    }
  };
}
